/**
 * Paramétrage OM
 */
export interface ParamOm {
    /** Données */
    actif: boolean;

    mibshow: boolean;

    plageHoraireShow: boolean;

    paysDestination: boolean;

    complementDestination: boolean;

    dateObligatoire: boolean;

    dateModifiable: boolean;

    idTraiteAvantLe: number;

    nbRepartitions: number;

    idModeParticipant: IdModeParticipantOption;

    idMailParticipant: number;

    collabNotPartAlowwed: boolean;

    creationForParticipant: boolean;

    emissionForParticipant: boolean;

    dateTransportIncluse: boolean;

    multiNdfAllowed: boolean;

    idModeDegrevement: number;
}

/**
 * Enumération des options de traitement avant le
 */
export enum IdTraiteAvantLeOption {
    NonRenseigne = 0,
    DateDuJour = 1,
    DateDebutMission = 2,
    VeilleDepartMission = 3
}

/**
 * Enumération des options de mode participant
 */
export enum IdModeParticipantOption {
    INTERNES_ET_EXTERNES = 0,
    INTERNES_UNIQUEMENT = 1,
    EXTERNES_UNIQUEMENT = 2,
    AUCUN = 3
}

/**
 * Enumération des options de mode de degrèvement
 */
export enum IdModeDegrevementOption {
    AUCUNE = 0,
    DETAILLE = 2
}